// 003: every string of the join screens, verbatim from the spec (FR-005 to FR-009, FR-019,
// FR-021, FR-024, FR-025; P-JOIN-4, P-JOIN-8). 004 reuses these for its own invalid states.
import type { Api } from "@/api/types";

export const JOIN_COPY = {
  productHeader: "Akaiva Edu Power",
  landing: {
    joiningPrefix: "You're joining ",
    joiningSuffix: " on Akaiva Edu Power",
    joining: (name: string) => `You're joining ${name} on Akaiva Edu Power`,
    continue: "Continue",
    notNow: "Not now",
    haveAccount: "Already have an account?",
    logIn: "Log in",
    checking: "Checking the school…",
  },
  invalid: "This school link isn't valid. Check with your school.",
  notActive: (name: string) =>
    `${name} isn't taking orders on Akaiva Edu Power yet.`,
  rateLimited: "Too many attempts. Please wait a few minutes and try again.",
  goToHome: "Go to Home",
  goToStart: "Continue",
  parentRole: {
    webMessage:
      "School links are for parent accounts. You're signed in as a school admin.",
    androidMessage:
      "The school admin console is available on the web at app.akaiva-edu.com",
    useAsParent: "Use as a parent too",
    goToSchoolAdmin: "Go to school admin",
    logOut: "Log out",
    noParentRole: "We couldn't turn on parent access. Try again.",
  },
  codeStep: {
    heading: "Enter your school code",
    hint: "Find it on the QR poster at your school or in your school's message",
    field: "School code",
    find: "Find school",
    confirm: "This is my school",
    change: "Change code",
    notFound:
      "We couldn't find a school with that code. Check the code and try again.",
    cancel: "Cancel",
    logOut: "Log out",
    switchToSchoolAdmin: "Switch to school admin",
  },
  addStudent: {
    title: "Add student",
    classes: "Classes",
    noClasses: "This school hasn't added its classes yet.",
    cancel: "Cancel",
  },
  chip: (name: string, source: Api["JoinSource"]) =>
    `${name} · ${source === "CODE" ? "via school code" : "via school link"}`,
  sourceLabel: (source: Api["JoinSource"]) =>
    source === "QR"
      ? "QR code"
      : source === "CODE"
        ? "School code"
        : "School link",
} as const;
